import { useCallback, useState } from "react";
import TitledText from "../TitledText/TitledText";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";
import styles from "./TitledTextWithModal.module.css";

type TitledTextWithModalProps = {
  title: string;
  text: string;
  modalHeader: string;
  modalCaption: string;
  modalFirstLine: string;
  modalSubsequentLines: string[];
};

function TitledTextWithModal({
  title,
  text,
  modalHeader,
  modalCaption,
  modalFirstLine,
  modalSubsequentLines,
}: TitledTextWithModalProps) {
  const { t } = useTranslation();
  const headerId = "task-management-titled-text-with-modal-header";
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
  }, []);

  return (
    <>
      <button
        className={styles["card"]}
        onClick={handleOpenModal}
        data-testid="TitledTextWithModal-OpenButton"
        type="button"
      >
        <TitledText title={title} text={text} />
      </button>
      <FixaModal visible={showModal} handleCloseBtn={handleCloseModal}>
        <FixaSheets
          labelledById={headerId}
          header={
            <FixaModalHeader
              id={headerId}
              title={modalHeader}
              closeBtnClick={handleCloseModal}
            />
          }
          footer={
            <FixaModalFooter renderBorder>
              <FixaButton
                type="primary"
                fluid
                text={t("confirmString")}
                onClick={handleCloseModal}
              />
            </FixaModalFooter>
          }
          fullSize
        >
          <FixaModalBody>
            <FixaText textStyle="Body.L" className={styles["header"]}>
              {modalCaption}
            </FixaText>
            <FixaText textStyle="Heading.S">{modalFirstLine}</FixaText>
            {modalSubsequentLines.map((line, index) => (
              <FixaText
                key={index}
                textStyle="Body.M"
                className={styles["line"]}
              >
                {line}
              </FixaText>
            ))}
            <hr className={styles["divider"]} />
          </FixaModalBody>
        </FixaSheets>
      </FixaModal>
    </>
  );
}

export default TitledTextWithModal;
